module.exports = __webpack_public_path__ + "static/img/3.4455b93.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/19/sp/3.png
// module id = tMeN
// module chunks = 0